const galleryInstances = new Map();
const reducedGalleryMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
function initializeHorizontalGallery(root) {
  const override = root.querySelector('.hl-gallery-mode-images');
  const grid = root.querySelector('.media-gallery__grid');
  const track = override || grid || (root.matches('[data-u-gallery]') ? root : root.querySelector('slideshow-slides'));
  if (!track) return;
  let instance = galleryInstances.get(root);
  if (instance && instance.track !== track) {
    instance.destroy();
    instance = null;
  }
  if (!instance) {
    root.classList.add('hl-horizontal-gallery');
    root.toggleAttribute('data-horizontal-grid', Boolean(grid));
    track.classList.add('hl-horizontal-track');
    track.tabIndex = 0;
    track.setAttribute('role', 'region');
    track.setAttribute('aria-roledescription', 'carousel');
    track.setAttribute('aria-label', root.dataset.horizontalLabel);
    const controls = document.createElement('div');
    controls.className = 'hl-horizontal-controls';
    const previous = document.createElement('button');
    previous.type = 'button';
    previous.setAttribute('aria-label', root.dataset.horizontalPrevious);
    previous.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m14 6-6 6 6 6"/></svg>';
    const next = document.createElement('button');
    next.type = 'button';
    next.setAttribute('aria-label', root.dataset.horizontalNext);
    next.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m10 6 6 6-6 6"/></svg>';
    const counter = document.createElement('span');
    counter.className = 'hl-horizontal-position';
    counter.setAttribute('aria-live', 'polite');
    counter.setAttribute('aria-atomic', 'true');
    controls.append(previous, counter, next);
    const stage = document.createElement('div');
    stage.className = 'hl-gallery-stage';
    root.before(stage);
    stage.append(root, controls);
    const title = document.querySelector('.hl-product-intro h1,.u-product__info h1');
    if (title) {
      const mobileTitle = document.createElement('p');
      mobileTitle.className = 'hl-gallery-mobile-title';
      mobileTitle.textContent = title.textContent.trim();
      stage.before(mobileTitle);
    }
    const abort = new AbortController();
    let frame = 0;
    let target = null;
    let settle = 0;
    const items = () => [...track.children].filter(e => !e.hidden && getComputedStyle(e).display !== 'none');
    const index = () => {
      const cards = items();
      const left = track.getBoundingClientRect().left;
      let selected = 0;
      let distance = Infinity;
      cards.forEach((card, i) => {
        const offset = Math.abs(card.getBoundingClientRect().left - left);
        if (offset < distance) { selected = i; distance = offset; }
      });
      return selected;
    };
    const sync = () => {
      frame = 0;
      const cards = items();
      const selected = index();
      counter.textContent = `${String(cards.length ? selected + 1 : 0).padStart(2, '0')} / ${String(cards.length).padStart(2, '0')}`;
      previous.disabled = selected === 0;
      next.disabled = selected >= cards.length - 1;
      controls.hidden = cards.length < 2;
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(sync); };
    const go = (step) => {
      const cards = items();
      target = Math.max(0, Math.min((target ?? index()) + step, cards.length - 1));
      const card = cards[target];
      if (card) track.scrollBy({left:card.getBoundingClientRect().left - track.getBoundingClientRect().left, behavior:reducedGalleryMotion() ? 'instant' : 'smooth'});
    };
    previous.addEventListener('click', () => go(-1), {signal:abort.signal});
    next.addEventListener('click', () => go(1), {signal:abort.signal});
    track.addEventListener('scroll', () => {
      schedule();
      clearTimeout(settle);
      settle = setTimeout(() => { target = null; sync(); }, 160);
    }, {signal:abort.signal, passive:true});
    track.addEventListener('pointerdown', () => { target = null; }, {signal:abort.signal});
    track.addEventListener('keydown', event => {
      if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      go(event.key === 'ArrowLeft' ? -1 : 1);
    }, {signal:abort.signal});
    const resize = new ResizeObserver(schedule);
    resize.observe(track);
    instance = {track, sync, reset:() => { track.scrollTo({left:0,behavior:'instant'}); target=null;sync(); }, destroy:() => {
      abort.abort();resize.disconnect();cancelAnimationFrame(frame);clearTimeout(settle);stage.previousElementSibling?.matches('.hl-gallery-mobile-title') && stage.previousElementSibling.remove();stage.before(root);stage.remove();track.classList.remove('hl-horizontal-track');galleryInstances.delete(root);
    }};
    galleryInstances.set(root, instance);
  }
  instance.sync();
}
const labels = document.querySelector('[data-horizontal-gallery-labels]');
let galleryFrame = 0;
function scanHorizontalGalleries() {
  galleryFrame = 0;
  for (const [root, instance] of galleryInstances) if (!root.isConnected) instance.destroy();
  document.querySelectorAll('.product-information__media media-gallery,[data-u-gallery]').forEach(root => {
    root.dataset.horizontalLabel = labels?.dataset.label || 'Product images';
    root.dataset.horizontalPrevious = labels?.dataset.previous || 'Previous image';
    root.dataset.horizontalNext = labels?.dataset.next || 'Next image';
    initializeHorizontalGallery(root);
  });
}
const galleryMain = document.querySelector('#MainContent');
if (galleryMain) {
  new MutationObserver(records => {
    if (!records.some(record => record.type === 'childList' && [...record.addedNodes,...record.removedNodes].some(node => node.nodeType === 1) || record.type === 'attributes' && record.target.matches('[data-u-media],.hl-gallery-mode-images > div,.product-media-container'))) return;
    if (!galleryFrame) galleryFrame = requestAnimationFrame(scanHorizontalGalleries);
  }).observe(galleryMain, {childList:true,subtree:true,attributes:true,attributeFilter:['hidden']});
  galleryMain.addEventListener('change', event => {
    if (!event.target.matches('variant-picker input,[data-u-option-group] input')) return;
    requestAnimationFrame(() => { scanHorizontalGalleries();galleryInstances.forEach(instance => instance.reset()); });
  });
  scanHorizontalGalleries();
}
